export default __webpack_public_path__ + "locales/ro/ArchiveDialog.json?hash=6c86ffef02cbc2dea751e06127b8d373";